import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "16",
  fill: "none",
  viewBox: "3024 393.5 20 16"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "m3030 409.5-1.4-1.425 2.575-2.575H3024v-2h7.175l-2.575-2.575 1.4-1.425 5 5zm8-6-5-5 5-5 1.4 1.425-2.575 2.575H3044v2h-7.175l2.575 2.575z",
      class: "fills",
      style: {"fill":"#1f7eff","fill-opacity":"1"}
    }, null, -1)
  ]))]))
}
export default { render: render }